var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 4H7.6C5.56 4 4 5.56 4 7.6V24.4C4 26.44 5.56 28 7.6 28H24.4C26.44 28 28 26.44 28 24.4V7.6C28 5.56 26.44 4 24.4 4ZM11.2 22C11.2 22.72 10.72 23.2 10 23.2C9.28 23.2 8.8 22.72 8.8 22V17.2C8.8 16.48 9.28 16 10 16C10.72 16 11.2 16.48 11.2 17.2V22ZM17.2 22C17.2 22.72 16.72 23.2 16 23.2C15.28 23.2 14.8 22.72 14.8 22V10C14.8 9.28 15.28 8.8 16 8.8C16.72 8.8 17.2 9.28 17.2 10V22ZM23.2 22C23.2 22.72 22.72 23.2 22 23.2C21.28 23.2 20.8 22.72 20.8 22V14.8C20.8 14.08 21.28 13.6 22 13.6C22.72 13.6 23.2 14.08 23.2 14.8V22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.b677d99fff8af97c3010b37d8984870f.svg";
export { ForwardRef as ReactComponent };